import React, {useEffect, useState} from 'react';
import {Avatar, Card, Typography} from "antd";
import {SettingOutlined, UserOutlined} from "@ant-design/icons";
import ChangePwForm from "../../components/Auth/ChangePwForm";
import {useQueryClient} from "@tanstack/react-query";
import {useSearchParams} from "react-router-dom";

const UserProfile = () => {
    const { Meta } = Card;
    const { Link} = Typography;
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const queryClient = useQueryClient();
    const userInfo = queryClient.getQueryData(['userInfo']);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        if (searchParams.get('changePw') === 'true') {
            setOpen(true);
            searchParams.delete('changePw');
            setSearchParams(searchParams, { replace: true });
        }
    }, [searchParams]);

    useEffect(() => {
        if (userInfo !== undefined) {
            setTitle(userInfo.data.name);
            setDescription(userInfo.data.role);
        }
    }, [userInfo]);


    return (
        <>
            <Card
                styles={{actions: {backgroundColor: 'rgb(220, 220, 220)', borderTop: '1px solid #c2c2c2'}}}
                style={{borderRadius: 0, backgroundColor: 'rgb(220, 220, 220)', minHeight: '10vh', boxShadow: 'none', borderBottom: '1px solid #c2c2c2'}}
                bordered={false}
                actions={[<Link onClick={() => setOpen(true)}><SettingOutlined style={{fontSize: 18}}/></Link>]}
            >
                <Meta avatar={<Avatar size='small' icon={<UserOutlined/>} />} title={title} description={description}/>
            </Card>
            <ChangePwForm userInfo={userInfo} open={open} setOpen={setOpen} />
        </>
    );
};

export default UserProfile;